import { useEffect, useRef } from "react";

type UnpublishConfirmPanelProps = {
  appName: string;
  loading: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

export function UnpublishConfirmPanel({
  appName,
  loading,
  onCancel,
  onConfirm,
}: UnpublishConfirmPanelProps) {
  const cancelRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    cancelRef.current?.focus();
  }, []);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape" && !loading) {
        onCancel();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [loading, onCancel]);

  return (
    <div
      aria-labelledby="unpublish-confirm-title"
      aria-modal="true"
      className="oac-form-message"
      role="dialog"
    >
      <p id="unpublish-confirm-title">
        <strong>Unpublish {appName}?</strong>
      </p>

      <p>
        This will remove the app from Discover and public installation. Your app
        record, versions, payment history and renewal history will be preserved.
      </p>

      <div>
        <button
          className="oac-btn oac-btn--outline"
          disabled={loading}
          onClick={onCancel}
          ref={cancelRef}
          type="button"
        >
          Cancel
        </button>
        <button
          className="oac-btn oac-btn--blue"
          disabled={loading}
          onClick={onConfirm}
          type="button"
        >
          {loading ? "Unpublishing…" : "Unpublish"}
        </button>
      </div>
    </div>
  );
}
